import _ from 'lodash';

import config from './config';

export const isPathHidden = (path) => {
  return !!_.find(config.hiddenPaths, (hiddenPath) => {
    return path.indexOf(hiddenPath) !== -1;
  });
};

export const isNavItemHidden = (path) => {
  return !!_.find(config.hiddenMenuPositions, (hiddenPath) => {
    return path.indexOf(hiddenPath) !== -1;
  });
};

export const isNavItemShown = (navItem) => {
  return !isPathHidden(navItem.path);
};

export const isConsoleItemHidden = (path) => {
  const pathName = path.path;
  return !config.hiddenMenuConsole.filter(hiddenPath => pathName.indexOf(hiddenPath) > -1).length;
};



// WEBPACK FOOTER //
// ./src/config/helpers.js